import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { CommonService } from 'src/app/Service/Common.service';
import { LoaderService } from 'src/app/Service/Loader/loader.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { PeerReviewService } from 'src/app/Service/peerReview/peer-review.service';
import { IPRInvitationDisciplineMasterDataOutputModel, IPRInvitationLocationMasterDataOutputModel, IPRInvitationMembersMasterDataOutputModel, IPRInvitationRoleMasterDataOutputModel } from 'src/app/ViewModel/PeerReviewModel';
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { MemberECDMDOutput } from 'src/app/ViewModel/ProjectElementsModel';


@Component({
  selector: 'app-pr-invitation',
  templateUrl: './pr-invitation.component.html',
  styleUrls: ['./pr-invitation.component.css']
})
export class PrInvitationComponent implements OnInit {
  projectId: number = 0;
  groupId: number = 0;
  memberId: number = 0;
  CurrentProjectDetails!: ProjectViewModel;
  PRInvitationRoleMasterDataOutputModel: IPRInvitationRoleMasterDataOutputModel[] = [];
  PRInvitationDisciplineMasterDataOutputModel: IPRInvitationDisciplineMasterDataOutputModel[] = [];
  PRInvitationLocationMasterDataOutputModel: IPRInvitationLocationMasterDataOutputModel[] = [];
  PRInvitationMembersMasterDataOutputModel: IPRInvitationMembersMasterDataOutputModel[] = [];
  formPRInvitation: FormGroup;
  selectedLocation!: number;
  /** Cart params data */
  cartARequest = {}
  cartBRequest = {}

  /** Left side cart data. Filtered with right side data */
  filteredCartAList: IPRInvitationMembersMasterDataOutputModel[] = [];
  filteredCartBList: IPRInvitationMembersMasterDataOutputModel[] = [];

  /** Cart selected (right side) data */
  cartASelectedList: any[] = [];
  cartBSelectedList: any[] = [];
  cartASelectedListCopy: any[] = [];
  cartBSelectedListCopy: any[] = [];
  selectedDGHBind: Array<any> = [];
  selectedDDGHBind: Array<any> = [];
  selectedOtherBind: Array<any> = [];
  selectedDescBind: Array<any> = [];
  selectedOtherHeadsBind: Array<any> = [];

  ExistingPRInviteMembers!: any[];
  GridAData: any[] = [];
  GridBData: any[] = [];
  gridViewA!: GridDataResult;
  gridViewB!: GridDataResult;
  pageSizeA = 10;
  skipA = 0;
  pageSizeB = 20;
  skipB = 0;
  PRreqno: string;

  dghRole: IPRInvitationMembersMasterDataOutputModel[] = [];
  otherHeadsRole: IPRInvitationMembersMasterDataOutputModel[] = [];
  ddghRole: IPRInvitationMembersMasterDataOutputModel[] = [];
  othermember: IPRInvitationMembersMasterDataOutputModel[] = [];
  selectedDGH: any[] = [];
  selectedOtherHeads: any[] = [];
  selectedDDGH: any[] = [];
  selectedOthers: any[] = [];
  bothDghnDdgh: any[] = [];
  selectedDiscipline: any[] = [];
  ecdmem: MemberECDMDOutput[] = [];
  mecdmem: MemberECDMDOutput[] = [];
  decdmem: MemberECDMDOutput[] = [];


  constructor(public dialogRef: MatDialogRef<PrInvitationComponent>, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public _data: any, private _CommonService: CommonService, private _NotificationService: NotificationService, private _LoaderService: LoaderService, private _PRService: PeerReviewService, private _formBuilder: FormBuilder) {
    this.formPRInvitation = this._formBuilder.group({
      location: new FormControl('', [Validators.required]),
      formLocation: new FormControl(''),
      role: new FormControl(''),
      formRole: new FormControl(''),
      discipline: new FormControl(''),
      formDiscipline: new FormControl('')
    });
    this.PRreqno = "Peer Review Invitation for " + this._data.newReqNo;
  }


  bindEditData() {
    this.bothDghnDdgh = []
    var K = [];
    var L = [];
    var M = [];
    var N = [];
    var O = [];
    var ddghList = this.ddghRole.filter(obj1 => JSON.parse(this._data.editData[0].jsnDDGH)?.some(obj2 => obj2.member_id === obj1.member_id))
    ddghList.filter((x: any) => {
      K = [...K, this.getAsCartSelectedValue(x.member_id, x.emp_name, x)];
      this.checkedDdgh(K);
    })
    this.selectedDDGHBind = ddghList.map(x => x.member_id);

    var dghList = this.dghRole.filter(obj1 => JSON.parse(this._data.editData[0].jsnDDh)?.some(obj2 => obj2.member_id === obj1.member_id))
    dghList.filter((x: any) => {
      L = [...L, this.getAsCartSelectedValue(x.member_id, x.emp_name, x)];
      this.checkedDgh(L);
    })
    this.selectedDGHBind = dghList.map(x => x.member_id);

    var otherHeads = this.otherHeadsRole.filter(obj1 => JSON.parse(this._data.editData[0].jsnDDh)?.some(obj2 => obj2.member_id === obj1.member_id))
    otherHeads.filter((x: any) => {
      O = [...O, this.getAsCartSelectedValue(x.member_id, x.emp_name, x)];
      this.checkedOtherHeads(O);
    })
    this.selectedOtherHeadsBind = otherHeads.map(x => x.member_id);
    var otherList = this.othermember.filter(obj1 => JSON.parse(this._data.editData[0].jsnOther)?.some(obj2 => obj2.member_id === obj1.member_id))
    otherList.filter((x: any) => {
      M = [...M, this.getAsCartSelectedValue(x.member_id, x.emp_name, x)];
      this.checkedOthers(M);
    })
    this.selectedOtherBind = otherList.map(x => x.member_id);

    var DescList = this.PRInvitationDisciplineMasterDataOutputModel.filter(obj1 => JSON.parse(this._data.editData[0].jsnDiscipline)?.some(obj2 => obj2.deD_Id === obj1.deD_Id))
    DescList.filter((x: any) => {
      N = [...N, this.getAsCartSelectedValue(x.deD_Id, x.discipline, x)];
      this.checkedDiscipline(N);
    })
    this.selectedDescBind = DescList.map(x => x.deD_Id);
    this.selectedLocation = JSON.parse(this._data.editData[0].meetingLocation)[0].deD_Id;

  }



  ngOnInit() {
    this.projectId = this._CommonService.getProjectId();
    this.memberId = this._CommonService.getLoggedInUserId();
    this.groupId = this._CommonService.getLoggedInUserGroupId();
    this.CurrentProjectDetails = this._CommonService.getCurrentProjectDetails();
    this.GetPRInvitationMembers();
    this.setCartAParams();
    this.setCartBParams();


    this._PRService.getECDMembers({
      intProjectID: this.projectId,
      intGroupID: this.groupId,
      intUID: this.memberId
    }).subscribe(res => {
      this.ecdmem = res.filter(x => x.short_desc == "ECD");
      this.mecdmem = res.filter(x => x.short_desc == "MECD");
      this.decdmem = res.filter(x => x.short_desc == "DECD");
    });

    this._PRService.getPRInvitationMasterData({ intUID: this.memberId, strDocNumber: this._data.requestNo })
      .subscribe(async (res: any) => {
        if (res) {
          this.PRInvitationLocationMasterDataOutputModel = res['prInvitationLocationMasterDataOutputModel'].map((x: any) => { x.deD_Description = x.deD_Short_Description + ' - ' + x.deD_Description; return x; });
          this.PRInvitationMembersMasterDataOutputModel = res['prInvitationMembersMasterDataOutputModel'];
          this.dghRole = this.PRInvitationMembersMasterDataOutputModel.filter(x => x.category == 'DGH' && x.psno == '80580');
          this.otherHeadsRole = this.PRInvitationMembersMasterDataOutputModel.filter(x => x.category == 'DGH' && x.psno != '80580');
          this.ddghRole = this.PRInvitationMembersMasterDataOutputModel.filter(x => x.category == 'DDGH');
          this.othermember = this.PRInvitationMembersMasterDataOutputModel.filter(x => x.category == 'OTHERS');
          if (this._data.editData != undefined) {
            this.bindEditData();
          }
          if(this._data.editData == undefined)
          {
            this.defaultPanelMembersList();
          }

        }
      }, err => { this._NotificationService.showToast(err, "Error"); });

    this._PRService.getPRInvitationRoleMasterData({ intUID: this.memberId })
      .subscribe(async (res: any) => {
        if (res.length > 0) {
          this.PRInvitationRoleMasterDataOutputModel = res.map((x: any) => { x.deD_Description = x.deD_Short_Description + ' - ' + x.deD_Description; return x; });
        }
      }, err => { this._NotificationService.showToast(err, "Error"); });

    this._PRService.getPRInvitationDisciplineMasterData({ intUID: this.memberId, intGroupID: this.groupId, intProjectID: this._CommonService.getProjectId(), intModuleID: 31 })
      .subscribe(async (res: any) => {
        if (res.length > 0) {
          this.PRInvitationDisciplineMasterDataOutputModel = res.map((x: any) => { x.discipline = x.discipline_Short_Description + ' - ' + x.discipline; return x; });
        }
      }, err => { this._NotificationService.showToast(err, "Error"); });
  }

  public pageChangeA(event: PageChangeEvent): void {
    this.skipA = event.skip;
    this.loadItemsA();
  }

  defaultPanelMembersList()
  {
    var deafultList:String[]= ['14866', '196929','20376114','20052371','20307019','20349067','20317694'];
    let N = []
    let desc = new Set<number>();
    deafultList.forEach(x=> {
      if(this.PRInvitationMembersMasterDataOutputModel.some(y => y.psno==x))
      {
        let mem = this.PRInvitationMembersMasterDataOutputModel.find(m => m.psno==x);
        let memDesc = mem.discipline_ded_id;
        if(!desc.has(memDesc))
        {
          desc.add(memDesc)
        }
        N = [...N, this.getAsCartSelectedValue(mem.member_id, mem.emp_name, mem)];
        this.SaveSelectedCartEditBItems(N);
      }
    })
    this.selectedDiscipline.forEach(x => {
      let filterdata = this.PRInvitationMembersMasterDataOutputModel.filter(item => item.discipline_ded_id == x.deD_Id);
      this.filteredCartBList = this.filteredCartBList.concat(filterdata);
    })
    this.selectedDescBind = [...desc];
    this.cartBSelectedList = N;
    this.setCartBParams()
  }


  private loadItemsA(): void {
    this.gridViewA = {
      data: this.GridAData.slice(this.skipA, this.skipA + this.pageSizeA),
      total: this.GridAData.length,
    };

    if (this.gridViewA["total"] == 0) {
      this.pageSizeA = 10;
      this.skipA = 0;
    }
  }

  public pageChangeB(event: PageChangeEvent): void {
    this.skipB = event.skip;
    this.loadItemsB();
  }

  private loadItemsB(): void {
    this.gridViewB = {
      data: this.GridBData.slice(this.skipB, this.skipB + this.pageSizeB),
      total: this.GridBData.length,
    };

    if (this.gridViewB["total"] == 0) {
      this.pageSizeB = 20;
      this.skipB = 0;
    }
  }

  checkedDgh(event: any) {
    if (event && event.length > 0) {
      this.selectedDGH = [];
      this.bothDghnDdgh = this.selectedDGH.concat(this.selectedOtherHeads.concat(this.selectedDDGH.concat(this.selectedOthers)));
      for (let obj of event) {
        this.selectedDGH.push(obj.additionalValues);
      }
      if (this.selectedDGH.length > 0) {
        this.bothDghnDdgh = this.selectedDGH.concat(this.selectedOtherHeads.concat(this.selectedDDGH.concat(this.selectedOthers)));
      }
    }
    else {
      this.selectedDGH = [];
    }
    if (event.length == 0) {
      this.selectedDGH = [];
      this.bothDghnDdgh = this.selectedDGH.concat(this.selectedOtherHeads.concat(this.selectedDDGH.concat(this.selectedOthers)));
    }
  }

  checkedOtherHeads(event: any) {
    if (event && event.length > 0) {
      this.selectedOtherHeads = [];
      this.bothDghnDdgh = this.selectedDGH.concat(this.selectedOtherHeads.concat(this.selectedDDGH.concat(this.selectedOthers)));
      for (let obj of event) {
        this.selectedOtherHeads.push(obj.additionalValues);
      }
      if (this.selectedOtherHeads.length > 0) {
        this.bothDghnDdgh = this.selectedDGH.concat(this.selectedOtherHeads.concat(this.selectedDDGH.concat(this.selectedOthers)));
      }

    } 
    else {
      this.selectedOtherHeads = [];
    }
    if (event.length == 0) {
      this.selectedOtherHeads = [];
      this.bothDghnDdgh = this.selectedDGH.concat(this.selectedOtherHeads.concat(this.selectedDDGH.concat(this.selectedOthers)));
    }
  }

  checkedDdgh(event: any) {
    if (event && event.length > 0) {
      this.selectedDDGH = [];
      this.bothDghnDdgh = this.selectedDGH.concat(this.selectedOtherHeads.concat(this.selectedDDGH.concat(this.selectedOthers)));
      for (let obj of event) {
        this.selectedDDGH.push(obj.additionalValues);
      }
      if (this.selectedDDGH.length > 0) {
        this.bothDghnDdgh = this.selectedDGH.concat(this.selectedOtherHeads.concat(this.selectedDDGH.concat(this.selectedOthers)));
      }
    }
    else {
      this.selectedDDGH = [];
    }

    if (event.length == 0) {
      this.selectedDDGH = [];
      this.bothDghnDdgh = this.selectedDGH.concat(this.selectedOtherHeads.concat(this.selectedDDGH.concat(this.selectedOthers)));
    }
  }




  checkedOthers(event: any) {
    if (event && event.length > 0) {
      this.selectedOthers = [];
      this.bothDghnDdgh = this.selectedDGH.concat(this.selectedOtherHeads.concat(this.selectedDDGH.concat(this.selectedOthers)));
      for (let obj of event) {
        this.selectedOthers.push(obj.additionalValues);
      }
      if (this.selectedOthers.length > 0) {
        this.bothDghnDdgh = this.selectedDGH.concat(this.selectedOtherHeads.concat(this.selectedDDGH.concat(this.selectedOthers)));
      }
    }
    else {
      this.selectedOthers = [];
    }

    if (event.length == 0) {
      this.selectedOthers = [];
      this.bothDghnDdgh = this.selectedDGH.concat(this.selectedOtherHeads.concat(this.selectedDDGH.concat(this.selectedOthers)));
    }
  }

  checkedDiscipline(event: any) {
    //  console.log(event);
    if (event && event.length > 0) {
      this.selectedDiscipline = [];
      this.filteredCartBList = [];
      for (let obj of event) {
        this.selectedDiscipline.push(obj.additionalValues);
      }
    }
    else {
      this.selectedDiscipline = [];
      this.filteredCartBList = [];
    }
    this.selectedDiscipline.forEach(x => {
      let filterdata = this.PRInvitationMembersMasterDataOutputModel.filter(item => item.discipline_ded_id == x.deD_Id);
      this.filteredCartBList = this.filteredCartBList.concat(filterdata);
    })
    if (this._data.editData != undefined) {
      this.cartASelectedList = this.filteredCartBList.filter(obj1 => JSON.parse(this._data.editData[0].strDiscipline).some(obj2 => obj2.member_id == obj1.member_id));

      var N = [];
      this.cartASelectedList.filter((x: any) => {
        N = [...N, this.getAsCartSelectedValue(x.member_id, x.emp_name, x)];
        this.SaveSelectedCartEditBItems(N);
      })
      this.cartBSelectedList = N;
      this.setCartAParams();
    }

    this.setCartBParams();
  }

  cancelRoleData(dataItem: any, rowIndex: any) {
    if (dataItem.category == 'DGH') {
      let dghindex = this.selectedDGH.indexOf(dataItem);
      this.selectedDGH.splice(dghindex, 1);
    }
    else if (dataItem.category == 'DDGH') {
      let ddghindex = this.selectedDDGH.indexOf(dataItem);
      this.selectedDDGH.splice(ddghindex, 1);
    }
    else if (dataItem.category == 'OTHERS') {
      let otherindex = this.selectedOthers.indexOf(dataItem);
      this.selectedOthers.splice(otherindex, 1);
    }
    this.bothDghnDdgh = this.selectedDGH.concat(this.selectedOtherHeads.concat(this.selectedDDGH.concat(this.selectedOthers)));
  }

  GetPRInvitationMembers() {
    this.ExistingPRInviteMembers = [];
    this._PRService.getPRInvitationMembers({ member_Id: this.memberId, review_No: this._data.requestNo })
      .subscribe(async (res: any) => {
        if (res) {
          this.selectedLocation = res.prInviteLocationOutputModel[0]?.lprE_DED_Id;
          this.ExistingPRInviteMembers = res.prInviteMembersOutputModel;
        }
      }, err => { this._NotificationService.showToast(err, "Error"); });
  }

  /**
  * Get elementDetailsForm Controls value
  * @param controlName ControlName
  */
  getFormValue(FormGroup: FormGroup, FormControlName: string,): any {
    return FormGroup.get(FormControlName);
  }

  setFormValue(form: FormGroup, formControlName: string, value: any) {
    form.get(formControlName)?.setValue(value);
  }

  formMarkAsTouched(form: FormGroup) {
    if (!form.valid)
      Object.keys(form.controls).forEach(key => {
        form.get(key)?.markAsTouched();
      });
  }

  onselectedValueChange(event: any, formGroupName: string, formControlName: string) {
    this.formPRInvitation.get(formControlName)?.setValue(event.additionalValues.additionalValues);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  cancelRowAData(dataItem: any, rowIndex: any) {
    this.GridAData.splice(rowIndex, 1);
    this.loadItemsA();
  }

  cancelRowBData(dataItem: any, rowIndex: any) {
    this.GridBData.splice(rowIndex, 1);
    this.loadItemsB();
  }

  /**
 * Change data to respective cart selected data format
 * @param value 
 * @param text 
 */
  getAsCartSelectedValue(value: string | number, text: string, x: any) {
    value = value.toString().trim();
    text = text.trim();
    let output = {
      value,
      text: value + ' - ' + text,
      additionalValues: x
    };
    return output;
  }

  async OnRoleChange(event: any) {
    this.cartASelectedList = [];
    this.filteredCartAList = [];
    this.cartASelectedListCopy = [];

    const objExistingPRInviteMembers = await this.PRInvitationMembersMasterDataOutputModel.filter(item => item.member_category_ded_id === event.value).filter(({ member_id: A_member_id, member_category_ded_id: member_category_ded_id, role_de_id: role_de_id, role_ded_id: role_ded_id }) => this.GridAData.filter(h => h.member_category_ded_id == member_category_ded_id && h.role_de_id == role_de_id && h.role_ded_id == role_ded_id).some(({ member_id: B_member_id }) => A_member_id === B_member_id));

    if (this.GridAData && this.GridAData.length > 0 && objExistingPRInviteMembers && objExistingPRInviteMembers.length > 0) {
      await objExistingPRInviteMembers.map(l => {
        let cartValue = this.getAsCartSelectedValue(l.member_id, l.emp_name, l);
        this.cartASelectedList.push(cartValue);
        this.cartASelectedListCopy.push(cartValue);
      });

      const objNewPRInviteMembers = await this.PRInvitationMembersMasterDataOutputModel.filter(item => item.member_category_ded_id === event.value).filter(({ member_id: A_member_id, member_category_ded_id: member_category_ded_id, role_de_id: role_de_id, role_ded_id: role_ded_id }) => this.GridAData.filter(h => member_category_ded_id == h.member_category_ded_id && role_de_id == h.role_de_id && role_ded_id == h.role_ded_id).every(({ member_id: B_member_id }) => A_member_id !== B_member_id));

      if (objNewPRInviteMembers)
        this.filteredCartAList = objNewPRInviteMembers;

      this.setCartAParams();
    }
    else {
      this.filteredCartAList = this.PRInvitationMembersMasterDataOutputModel.filter(item => item.member_category_ded_id === event.value);
      this.cartASelectedList = [];
      this.setCartAParams();
    }
  }

  async OnDisciplineChange(event: any) {
    this.cartBSelectedList = [];
    this.filteredCartBList = [];
    this.cartBSelectedListCopy = [];

    const objExistingPRInviteMembers = await this.PRInvitationMembersMasterDataOutputModel.filter(item => item.discipline_ded_id === event.value).filter(({ member_id: A_member_id, member_category_ded_id: member_category_ded_id, discipline_de_id: discipline_de_id, discipline_ded_id: discipline_ded_id }) => this.GridBData.filter(h => member_category_ded_id == h.member_category_ded_id && discipline_de_id == h.discipline_de_id && discipline_ded_id == h.discipline_ded_id).some(({ member_id: B_member_id }) => A_member_id === B_member_id));

    if (this.GridBData && this.GridBData.length > 0 && objExistingPRInviteMembers && objExistingPRInviteMembers.length > 0) {
      await objExistingPRInviteMembers.map(l => {
        let cartValue = this.getAsCartSelectedValue(l.member_id, l.emp_name, l);
        this.cartBSelectedList.push(cartValue);
        this.cartBSelectedListCopy.push(cartValue);
      });

      const objNewPRInviteMembers = await this.PRInvitationMembersMasterDataOutputModel.filter(item => item.discipline_ded_id === event.value).filter(({ member_id: A_member_id, member_category_ded_id: member_category_ded_id, discipline_de_id: discipline_de_id, discipline_ded_id: discipline_ded_id }) => this.GridBData.filter(h => member_category_ded_id == h.member_category_ded_id && discipline_de_id == h.discipline_de_id && discipline_ded_id == h.discipline_ded_id).every(({ member_id: B_member_id }) => A_member_id !== B_member_id));

      if (objNewPRInviteMembers)
        this.filteredCartBList = objNewPRInviteMembers;

      this.setCartBParams();
    }
    else {
      this.filteredCartBList = this.PRInvitationMembersMasterDataOutputModel.filter(item => item.discipline_ded_id == event.value);
      this.cartBSelectedList = [];
      this.setCartBParams();
    }
  }

  /**
   * Setting cart A data
   */
  setCartAParams() {
    this.cartARequest = {
      'params': {
        'LockingType': 'P',
        'selectedCartItems': this.cartASelectedList
      },
      'settings': {
        'mode': 'popup',
        'textField': 'emp_name',
        'valueField': 'member_id',
        'cartLabel': 'Role-Wise Members',
        'minimumSelectedItemCount': 0,
        'maximumSelectedItemCount': -1
      },
      'dataSource': this.filteredCartAList,
    }
  }

  /**
   * Setting cart B data
   */
  setCartBParams() {
    this.cartBRequest = {
      'params': {
        'LockingType': 'P',
        'selectedCartItems': this.cartBSelectedList
      },
      'settings': {
        'mode': 'popup',
        'textField': 'emp_name',
        'valueField': 'member_id',
        'cartLabel': 'Discipline-Wise Members',
        'minimumSelectedItemCount': 0,
        'maximumSelectedItemCount': -1
      },
      'dataSource': this.filteredCartBList,
    }
  }

  async SaveSelectedCartAItems(event: any[]) {
    if (event && event.length > 0) {
      await this.GridAData.filter(a => a.member_category_de_id === event.map(x => x.additionalValues.member_category_de_id)[0] && a.role_ded_id === event.map(x => x.additionalValues.role_ded_id)[0]).forEach(x => this.GridAData.splice(this.GridAData.indexOf(x), 1))

      event.map(x => { this.GridAData.push(x.additionalValues) });
    }
    else {
      await this.GridAData.filter(a => a.member_category_de_id === this.getFormValue(this.formPRInvitation, 'role').value["dE_Id"] && a.member_category_ded_id === this.getFormValue(this.formPRInvitation, 'role').value["deD_Id"]).forEach(x => this.GridAData.splice(this.GridAData.indexOf(x), 1))
    }
    await this.loadItemsA();

    this._NotificationService.showToast("Members Added for PR Invite!!!", "Success");
  }

  async SaveSelectedCartBItems(event: any[]) {
    if (event && event.length > 0) {
      event.forEach(x => {
        if (!this.GridBData.some(y => y.member_id == x.additionalValues.member_id && y.discipline_ded_id == x.additionalValues.discipline_ded_id)) {
          this.GridBData.push(x.additionalValues);
        }
      });
    }

    await this.loadItemsB();
    this._NotificationService.showToast("Members Added for PR Invite!!!", "Success");
    this.cartBSelectedList = [];
  }

  async SaveSelectedCartEditBItems(value: any[]) {
    if (value && value.length > 0) {
      value.forEach(x => {
        if (!this.GridBData.some(y => y.member_id == x.additionalValues.member_id && y.discipline_ded_id == x.additionalValues.discipline_ded_id)) {
          this.GridBData.push(x.additionalValues);
        }
      });
    }

    await this.loadItemsB();
    //this.cartBSelectedList = [];
  }

  async SaveInvite() {
    //if (this.formPRInvitation.valid && this.selectedDGH.length>0 && this.selectedDDGH.length>0)
    if (this.formPRInvitation.valid && this.gridViewB) {
      let y = this.bothDghnDdgh.concat(this.GridBData);
      let PRInvitationSaveMembers: any = await {
        document_Ref_No: this._data.requestNo,
        uID: this.memberId,
        location: { Location_DE_Id: this.getFormValue(this.formPRInvitation, 'location').value["dE_Id"], Location_DED_Id: this.getFormValue(this.formPRInvitation, 'location').value["deD_Id"] },
        activePRInvitationMembers: y && y.length > 0 ? y.map(x => {
          let c: any = {
            member_category_de_id: x.member_category_de_id,
            member_category_ded_id: x.member_category_ded_id,
            member_id: x.member_id,
            psno: x.psno,
            role_de_id: x.role_de_id,
            role_ded_id: x.role_ded_id,
            discipline_de_id: x.discipline_de_id,
            discipline_ded_id: x.discipline_ded_id,
            mail_id: x.mail_id,
            member_name: x.emp_name
          }
          return c;
        }) : [],
        inActivePRInvitationMembers: []
      }

      this._PRService.postPRInvitationMembers(PRInvitationSaveMembers)
        .subscribe(async (res: any) => {
          if (res.successCode == 200)
            this._NotificationService.showPopup(res.successMessage, "Success").then(
              x => this.closeDialog()
            );
          else
            this._NotificationService.showPopup(res.successMessage, "Warning");

        }, err => { this._NotificationService.showPopup(err, "Warning"); });
    }
    else {
      this._NotificationService.showPopup("Fill the mandatory fields", "Warning");
      this.formMarkAsTouched(this.formPRInvitation);
    }
  }
}
